import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import styles from "./TagRow.css";

export default function ReducedTagRow({ tag, className }) {
  return (
    <div
      className={classNames(styles.root, styles.reduced, className)}
      key={tag.id}
    >
      <span className={styles.name}>{tag.name}</span>
      <span className={classNames(styles.col, styles.reduced)}>
        {tag.stories} {tag.stories == 1 ? "story" : "stories"}
      </span>
    </div>
  );
}

ReducedTagRow.propTypes = {
  className: PropTypes.string,
  tag: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    stories: PropTypes.number,
  }),
};
